"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    powerBarContainer: 5,
    stepConnectingArrow: 4,
    stepHeaderDropdownMenu: 3,
    step: 2,
};
